export const proyectosMainBanner = [
  {
    image: './assets/imgs/nosotros/banner/fondo.png',
    color: '#000',
    text: '<span>PROYECTOS</span>',
  }

];

export const proyectosMainBannerEn = [
  {
    image: './assets/imgs/nosotros/banner/fondo.png',
    color: '#EA0029',
    text: 'PROJECTS',
  }
];